import { render, staticRenderFns } from "./HelpsPatient.vue?vue&type=template&id=7e472e33&scoped=true"
import script from "./HelpsPatient.vue?vue&type=script&lang=js"
export * from "./HelpsPatient.vue?vue&type=script&lang=js"
import style0 from "./HelpsPatient.vue?vue&type=style&index=0&id=7e472e33&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e472e33",
  null
  
)

export default component.exports